/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S6_Li2_AInputs */

const tr_mesafeli_s6_li2_a = /** @type {(inputs: Mesafeli_S6_Li2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri, aboneliğin süre sonunda sona ermesini ve hatırlatma almak istemediğini Platform içi`)
};

const en_mesafeli_s6_li2_a = /** @type {(inputs: Mesafeli_S6_Li2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Customer may record that the Subscription is to end with the term and that no reminder is wanted via the`)
};

const de_mesafeli_s6_li2_a = /** @type {(inputs: Mesafeli_S6_Li2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Kunde kann festlegen, dass das Abonnement mit der Laufzeit endet und keine Erinnerung kommt, über die Seite`)
};

const ru_mesafeli_s6_li2_a = /** @type {(inputs: Mesafeli_S6_Li2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Клиент может зафиксировать, что Подписка прекращается по окончании срока и напоминания не нужны, на странице Платформы`)
};

/**
* | output |
* | --- |
* | "The Customer may record that the Subscription is to end with the term and that no reminder is wanted via the" |
*
* @param {Mesafeli_S6_Li2_AInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s6_li2_a = /** @type {((inputs?: Mesafeli_S6_Li2_AInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S6_Li2_AInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s6_li2_a(inputs)
	if (locale === "de") return de_mesafeli_s6_li2_a(inputs)
	if (locale === "ru") return ru_mesafeli_s6_li2_a(inputs)
	return tr_mesafeli_s6_li2_a(inputs)
});